import React from "react";
import { type FieldValues, useForm } from "react-hook-form";
//import Button from "../../components/shared/button";
// import { DatePicker } from "../../components/shared/inputs/datePicker";
// import Input, {
//   InputType,
//   Password,
// } from "../../components/shared/inputs/input";
import Select, { TreeSelect } /*TreeSelect*/ from "../../components/shared/inputs/select";
import {
  //SvgDelete,
  //SvgEdit,
  SvgHelp,
  /*SvgLoaderCircleSmall,*/
  // SvgType_1,
  //SvgType_2,
  //SvgType_3,
  //SvgType_4,
} from "../../components/svg";

// import sampleImage from "../../styles/images/samples/sample_3.jpg";
// import Checkbox, { CheckboxType } from "components/shared/inputs/checkbox";
//import OptionBar from "components/shared/optionBar";
//import Radio, { RadioType } from "components/shared/inputs/radio";
import Tooltip from "antd/lib/tooltip";
import Checkbox from "components/shared/inputs/checkbox";
import { DatePicker } from "components/shared/inputs/datePicker";

const Form: React.FC = () => {
  const { control } = useForm<FieldValues>({
    defaultValues: {
      4: true,
      7: true,
      6: true,
      8: "Option3",
      checkox_option_9: true,
      checkox_option_7: true,
      checkox_option_6: true,
      RadioDemo4: "yes",

      RadioDemo2: "table_View",
      RadioDemo6: "leaf",
    },
  });

  return (
    <view data-vertical="" data-adaptive="">
      <view data-container="" data-scroll="">
        <group data-justify="center" data-align="center" data-gap="5" data-elevation="1" data-index="2" data-background="main-color-custom-light" data-backdrop="" data-wrap="no">
          <group data-wrap="no" data-space="10" data-space-vertical="30" data-gap="20" data-max-length='1440'>
            <group data-height="30" data-length="5" data-background="main"></group>
            <group data-length="autofit" ><text data-color="main" data-text-size="22">Nos solutions</text></group>
          </group>
        </group>

        <group data-justify="center" data-align="center" data-gap="5" data-elevation="1" data-index="3" data-backdrop="" data-wrap="no" data-sticky="top">
          <group data-wrap="no" data-space="10" data-space-vertical="15" data-gap="20" data-align="center" data-max-length='1440' data-name="breadcrumb">
            <group data-width="auto" data-gap="10" data-cursor="pointer" data-space="5" data-name="breadcrumb_item" data-wrap="no">
              <group data-adaptive="desktop" data-space="1" data-length="20" data-height="20" data-align="center" data-justify="center" data-radius="30" data-background="main-lighter" data-color="main" >2</group>
              <group data-adaptive="mobile" data-space="1" data-length="20" data-height="20" data-align="center" data-justify="center" data-radius="30" data-background="main-lighter"><icon data-icon-size="small" data-color="main">check</icon></group>
              <text data-adaptive="desktop" data-color="" data-weight="300" data-text-size="14" data-ellipsis="">Choix PAC</text>
            </group>
            <icon data-opacity="10">arrow_forward_ios</icon>
            <group data-width="auto" data-gap="10" data-cursor="pointer" data-space="5" data-name="breadcrumb_item" data-wrap="no">
              <group data-adaptive="desktop" data-space="1" data-length="20" data-height="20" data-align="center" data-justify="center" data-radius="30" data-background="main-lighter" data-color="main" >2</group>
              <group data-adaptive="mobile" data-space="1" data-length="20" data-height="20" data-align="center" data-justify="center" data-radius="30" data-background="main-lighter"><icon data-icon-size="small" data-color="main">check</icon></group>
              <text data-adaptive="desktop" data-color="" data-weight="300" data-text-size="14" data-ellipsis="">Choix PAC</text>
            </group>
            <icon data-opacity="10">arrow_forward_ios</icon>
            <group data-width="auto" data-gap="10" data-cursor="pointer" data-space="5" data-name="breadcrumb_item" data-wrap="no">
              <group data-space="1" data-length="20" data-height="20" data-align="center" data-justify="center" data-radius="30" data-background="main" data-color="white" >1</group>
              <text data-color="" data-weight="500" data-text-size="14" data-ellipsis="">Nos solutions</text>
            </group>
          </group>
        </group>

        <group data-justify="center" data-align="center" data-gap="5" data-elevation="1" data-index="3" data-backdrop="" data-wrap="no" data-sticky="top" >
          <group data-wrap="no" data-space="10" data-space-vertical="15" data-align="center" data-max-length="1440" data-name="breadcrumb thermor">
            <label
              radio=""
              data-custom=""
              className="fill"
            >
              <input
                type="radio"
                name="1"
                checked
                aria-hidden="true"
              />
              <box>
                <check></check>
                <ink></ink>
              </box>
              <text>Habitation</text>
              <separator data-horizontal=""></separator>
            </label>
            <separator data-horizontal="" className="fill"></separator>
            <label
              radio=""
              data-custom=""
              className="fill"
            >
              <input
                type="radio"
                name="1"
                //checked
                aria-hidden="true"
              />
              <box>
                <check></check>
                <ink></ink>
              </box>
              <text>Choix PAC</text>
              <separator data-horizontal=""></separator>
            </label>
            <separator data-horizontal="" className="fill"></separator>
            <label
              radio=""
              data-custom=""
              className="fill"
            >
              <input
                type="radio"
                name="1"
                //checked
                aria-hidden="true"
              />
              <box>
                <check></check>
                <ink></ink>
              </box>
              <text>Résultats</text>
              <separator data-horizontal=""></separator>
            </label>
            <separator data-horizontal="" className="fill"></separator>
            <label
              radio=""
              data-custom=""
              className="fill"
            >
              <input
                type="radio"
                name="1"
                checked
                aria-hidden="true"
              />
              <box>
                <check></check>
                <ink></ink>
              </box>
              <text>Accessoires</text>
              <separator data-horizontal=""></separator>
            </label>
            <separator data-horizontal="" 
            //className="fill"
            ></separator>
            <label
              radio=""
              data-custom=""
              //className="fill"
              //checked
            >
              <input
                type="radio"
                name="1"
                checked
                aria-hidden="true"
              />
              <box>
                <check></check>
                <ink></ink>
              </box>
              <text>Documents & devis</text>
              <separator data-horizontal=""></separator>
            </label>            
          </group>



        </group>


        <group data-direction="column" data-align="center" data-height="autofit">
          <group data-space="20" data-gap="20" data-max-length='800' data-direction="column">

            <group data-align="center" data-space-vertical="20">
              <text
                data-weight="400"
                data-text-size="large"
                data-ellipsis=""
                data-color="grey-color-dark"
              >
                <i data-space-horizontal="5" data-color="red">*</i> Champs obligatoires
              </text>
            </group>

            <group
              data-length="autofit"
              data-gap="20"
            >
              <group
                data-gap="10"
                data-space="10"
                //data-background="accent-xtralight"
                data-radius="10"
                data-direction="column"
              >
                <group data-gap="10">
                  <group data-length="autofit">
                    <material
                      className="empty"
                      data-size="large"
                      data-length="autofit"
                    >
                      <div className="field">
                        <label className="form_fields">
                          <div className="data_label">
                            <text data-ellipsis="">
                              Input component
                            </text>
                            <Tooltip
                              arrow={false}
                              color="var(--accent-dark)"
                              //space={false}
                              title={
                                <group
                                  data-direction="column"
                                  data-gap="10"
                                  data-space="5"
                                >
                                  <text data-weight="700">
                                    This's a tooltip
                                  </text>
                                </group>
                              }
                            >
                              <icon data-help="">
                                <SvgHelp />
                              </icon>
                            </Tooltip>
                          </div>
                          <div className="field_cont">
                            <input
                              type="text"
                              placeholder=" "
                              name="asd"
                              value=""
                            />
                            <div
                              className="marker"
                              data-radius="less-special"
                            >
                              <text>mm</text>
                            </div>
                            <i></i>
                          </div>
                        </label>
                      </div>
                    </material>
                  </group>
                  <group data-length="autofit">
                    <material
                      className=""
                      data-size="large"
                      data-length="autofit"
                    >
                      <div className="field">
                        <label className="form_fields">
                          <div className="data_label">
                            <text data-ellipsis="">
                              Input component
                            </text>
                            <Tooltip
                              arrow={false}
                              color="var(--accent-dark)"
                              //space={false}
                              title={
                                <group
                                  data-direction="column"
                                  data-gap="10"
                                  data-space="5"
                                >
                                  <text data-weight="700">
                                    This's a tooltip
                                  </text>
                                </group>
                              }
                            >
                              <icon data-help="">
                                <SvgHelp />
                              </icon>
                            </Tooltip>
                          </div>
                          <div className="field_cont">
                            <input
                              type="text"
                              placeholder=" "
                              name="asd"
                              value="Input value"
                            />
                            <div
                              className="marker"
                              data-radius="less-special"
                            >
                              <text>mm</text>
                            </div>
                            <i></i>
                          </div>
                        </label>
                      </div>
                    </material>
                  </group>
                </group>
              </group>
            </group>


            <group
              data-length="autofit"
              data-gap="20"
            >
              <group
                data-gap="10"
                data-space="10"
                //data-background="accent-xtralight"
                data-radius="10"
                data-direction="column"
              >
                <group data-align="center" data-width="auto" data-gap="10">
                  <text
                    data-weight="600"
                    data-text-size="large"
                    data-ellipsis=""
                    data-color="grey-color-dark"
                  >
                    Données géographiques
                  </text>
                  <a href="#" data-type="group" data-width="auto" data-gap="5" data-interactive="highlight">
                    <icon data-svg-color="secondary" data-svg-size="20"><SvgHelp /></icon>
                    <text
                      data-weight="600"
                      data-text-size="medium"
                      data-ellipsis=""
                      data-color="secondary"
                    >
                      En savoir +
                    </text>
                  </a>

                </group>
                <group data-gap="20">
                  <group data-length="autofit" data-direction="column">
                    <div className="field" data-size="large">
                      <label className="form_fields">
                        <div className="data_label">
                          <text data-ellipsis="">
                            Département<i data-space-horizontal="5" data-color="red">*</i>
                          </text>
                          <Tooltip
                            arrow={false}
                            color="var(--accent-dark)"
                            //space={false}
                            title={
                              <group
                                data-direction="column"
                                data-gap="10"
                                data-space="5"
                              >
                                <text data-weight="700">
                                  This's a tooltip
                                </text>
                              </group>
                            }
                          >
                            <icon data-help="">
                              <SvgHelp />
                            </icon>
                          </Tooltip>
                        </div>
                        <div className="field_cont">
                          <input
                            type="text"
                            placeholder=" "
                            name="asd"
                            value=""
                          />
                          <i></i>
                        </div>
                      </label>
                    </div>
                  </group>
                  <group data-width="auto" data-direction="column">
                    <div className="field" data-length="280" data-size="large">
                      <div className="form_fields validationError">
                        <div className="data_label">Search Here</div>
                        <div className="field_cont">
                          <icon data-space="5">search</icon>
                          <input placeholder="Search" type="text" />
                          <i></i>
                        </div>
                        <errormessage data-gap="5">
                          <icon data-svg-color="error-color" data-svg-size="16"><SvgHelp /></icon>
                          <text data-wrap="wrap" className="errorMessage">Name is required</text>
                        </errormessage>
                      </div>
                    </div>
                  </group>
                </group>
              </group>
            </group>

            <group
              data-length="autofit"
              data-gap="20"
            >
              <group
                data-gap="10"
                data-space="10"
                //data-background="accent-xtralight"
                data-radius="10"
                data-direction="column"
              >
                <group data-gap="20">
                  <group data-length="autofit" data-direction="column" data-justify="end">
                    <div className="field" data-size="large">
                      <label className="form_fields">
                        <div className="data_label">
                          <text data-ellipsis="">
                            Altitude (m) <i data-space-horizontal="5" data-color="red">*</i>
                          </text>
                        </div>
                        <div className="field_cont">
                          <input
                            type="text"
                            placeholder=" "
                            name="asd"
                            value=""
                          />
                          <i></i>
                        </div>
                      </label>
                    </div>
                  </group>

                  <group data-width="auto" data-direction="column" data-justify="end">
                    <div className="field" data-length="280" data-size="large">
                      <div className="form_fields">
                        <div className="data_label">Température de base (°C) <i data-space-horizontal="5" data-color="red">*</i></div>
                        <div className="field_cont">
                          <input placeholder="Search" type="text" />
                          <i></i>
                        </div>
                      </div>
                    </div>
                  </group>

                  <group data-width="auto" data-direction="column" data-justify="end">
                    <group data-space="10" data-gap="10" data-align="center" >
                      <Checkbox
                        name="1"
                        label="Classic Checkbox"
                        checkbox
                        control={control}
                      />
                      <group data-width="auto">

                        <Tooltip
                          arrow={false}
                          color="var(--accent-dark)"
                          //space={false}
                          title={
                            <group
                              data-direction="column"
                              data-gap="10"
                              data-space="5"
                            >
                              <text data-weight="700">
                                This's a tooltip
                              </text>
                            </group>
                          }
                        >
                          <icon data-svg-size="24" data-svg-color="secondary" data-cursor="pointer" >
                            <SvgHelp />
                          </icon>
                        </Tooltip>
                      </group>
                    </group>
                  </group>
                </group>
              </group>
            </group>


            <group
              data-length="autofit"
              data-gap="20"
            >
              <group
                data-gap="10"
                data-space="10"
                //data-background="accent-xtralight"
                data-radius="10"
                data-direction="column"
              >

                <group data-width="auto" data-direction="column" data-justify="end">
                  <group data-gap="20" data-align="center" data-name="custom_option">
                    <group data-wrap="no" data-cursor="pointer" data-interactive="" data-name="custom_option_select" data-length="230" data-height="100" data-space="15" data-gap="15" data-align="center" data-border='inheret' data-color="main" data-background="main-color-custom-lighter">
                      <icon data-svg-size="24" data-svg-color="main">
                        <SvgHelp />
                      </icon>
                      <text data-clamp="2" data-wrap="wrap">Maison seule</text>
                      <icon data-svg-size="16" data-svg-color="main" data-position="right">
                        <SvgHelp />
                      </icon>
                    </group>

                    <group data-wrap="no" data-cursor="pointer" data-interactive="" data-length="230" data-height="100" data-space="15" data-gap="15" data-align="center" data-border='inheret' data-color="main">
                      <icon data-svg-size="24" data-svg-color="main">
                        <SvgHelp />
                      </icon>
                      <text data-clamp="2" data-wrap="wrap">Maison mitoyenne sur 1 mur</text>
                      <icon data-svg-size="16" data-svg-color="main" data-position="right">
                        <SvgHelp />
                      </icon>
                    </group>
                    <group data-wrap="no" data-cursor="pointer" data-interactive="" data-length="230" data-height="100" data-space="15" data-gap="15" data-align="center" data-border='inheret' data-color="main">
                      <icon data-svg-size="24" data-svg-color="main">
                        <SvgHelp />
                      </icon>

                      <text data-clamp="2" data-wrap="wrap">Maison mitoyenne sur 1 mur</text>

                      <icon data-svg-size="16" data-svg-color="main" data-position="right">
                        <SvgHelp />
                      </icon>
                    </group>

                  </group>
                </group>
              </group>
            </group>

            <group data-align="center" data-space-vertical="20" >
              <group data-space="40" data-background="main-color-custom-lighter" data-radius="20" data-contain="">
                <group data-gap="20" data-align="center">
                  <text
                    data-weight="600"
                    data-text-size="22"
                    data-ellipsis=""
                    data-color="grey-color-dark"
                  >
                    Déperditions
                  </text>
                  <text
                    data-weight="600"
                    data-text-size="40"
                    data-ellipsis=""
                    data-color="main"
                  >
                    4988 W
                  </text>
                </group>
                <group data-gap="10" data-text-size="large" data-weight="400">
                  <text data-ellipsis=""> Coefficient de déperditions G : </text>
                  <text data-ellipsis=""> 0,98 W/m3/K </text>
                </group>
              </group>
            </group>

            <group data-align="center" data-space-vertical="20">
              <label checkbox="" data-simple="" className="" data-gap="10">
                <input placeholder=" " type="checkbox" name="3" />
                <text className="" data-text-size="22">Estimer un besoin froid</text>
                <box><check></check></box>
              </label>
            </group>


            <group data-background="accent-xtralight" data-direction="column">
              <group
                data-length="autofit"
                data-gap="20"
              >
                <group
                  data-gap="10"
                  data-space="10"
                  //data-background="accent-xtralight"
                  data-radius="10"
                  data-direction="column"
                >
                  <group data-gap="20">
                    <group data-width="auto" data-direction="column">
                      <Select
                        size="large"
                        icon="person"
                        label="Person"
                        placeholder="Select a person"
                        name="dropdown"
                        dataLength="240"
                        allowClear
                        options={[
                          "Wolverine",
                          "Spider-Man",
                          "Thor",
                          "Iron Man",
                          "Hulk",
                          "Captain America",
                          "Daredevil",
                          "Punisher",
                          { value: 1, text: "Yondu Udonta" },
                          { value: "Star Lord" },
                        ]}
                      />

                    </group>
                  </group>
                </group>
              </group>

              <group
                data-length="autofit"
                data-gap="20"
              >
                <group
                  data-gap="10"
                  data-space="10"
                  //data-background="accent-xtralight"
                  data-radius="10"
                  data-direction="column"
                >
                  <group data-gap="20">
                    <group data-width="auto" data-direction="column">
                      <DatePicker
                        size="large"
                        allowClear
                        icon="home"
                        name="dt"
                        label="Birthday"
                        placeholder="Select a Date"
                      />

                    </group>
                  </group>
                </group>
              </group>


              <group
                data-length="autofit"
                data-gap="20"
              >
                <group
                  data-gap="10"
                  data-space="10"
                  //data-background="accent-xtralight"
                  data-radius="10"
                  data-direction="column"
                >
                  <group data-gap="20">
                    <group data-width="auto" data-direction="column">

                      <TreeSelect
                        size="large"
                        treeLine
                        suffixIcon={null}
                        // switcherIcon={
                        //   <group data-name="tree-icon">
                        //     <icon data-icon-size="24" data-icon-weight="600">
                        //       expand_more
                        //     </icon>
                        //   </group>
                        // }
                        labelPosition="left"
                        dataLength="260"
                        name="treeSelect"
                        label="TreeSelect"
                        placeholder="Select a node"
                      //treeData={treeData}
                      />

                    </group>
                  </group>
                </group>
              </group>
            </group>

          </group>
        </group>
      </view>
    </view>
  );
};
export default Form;
